<template>
  <div>
    <button :disabled="$store.state.isonlyread" v-show="estudiantes.length > 0" class="btn btn-sm btn-link" @click="tableToExcel('table', 'Lorem Table')">
      <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL
    </button>
    <v-row v-if="estudiantes.length" no-gutters class="mb-3">
      <v-col cols="12" class="pb-0 mt-4">
        <p class="my-0 text-left green--text">fecha finalizacion del programa: {{ fecha_fin }}</p>
        <p class="mb-0 blue--text"><b>Seleccione los conceptos para ver la asignacion.</b></p>
      </v-col>
      <v-col cols="2" v-for="(c, ind) in xconceptos" :key="ind">
        <v-checkbox
          class="pt-0 mt-0"
          v-model="xconcetoschecks"
          :label="c.concepto_pago"
          :value="c.concepto_pago_id"
          :color="c.color"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="4" class="py-0 my-0">
        <v-text-field
          v-if="estudiantes.length"
          class="mt-2"
          label="Buscar"
          placeholder="texto a buscar...."
          hide-details
          outlined
          dense
          v-model="xfiltro"
          v-on:keyup.enter="findtext"
        ></v-text-field>
      </v-col>
    </v-row>

    <p class="text-center green--text">
      {{ xmsg }}
    </p>

    <div v-if="tipoasignacion && tipoasignacion.id == 1" class="table-responsive" style="height: 62vh;">
      <table
        v-if="estudiantes.length"
        class="ctable table-hover table-condensed table-striped"
        style="min-width:100%;line-height: 1em;"
        id="midatatable"
        ref="table"
      >
        <thead style="background:#196391;position: sticky; top: 0; z-index: 1;">
          <tr class="white--text text-center">
            <td rowspan="3" class="fixedheader" style="padding-left:12px;padding-right:12px;min-width:250px!important">
              DATOS PERSONA
            </td>
            <td v-for="(c, ind) in xconceptos" :key="ind" v-show="c.show" :style="'background:' + c.color" colspan="11">
              {{ c.concepto_pago }}
            </td>
          </tr>
          <tr class="white--text text-center" style="background:#BFAA6B;">
            <td
              v-for="(f, ind) in primerafila"
              :key="ind"
              v-show="f.show"
              :style="'background:' + f.color + ';min-width:100px'"
              :colspan="f.colspan"
              :rowspan="f.rowspan"
            >
              {{ parsetitulo(f.nombre) }}
            </td>
          </tr>
          <tr class="white--text text-center" style="background:#BFAA6B;">
            <td
              v-for="(f, ind) in segundafila"
              :key="ind"
              v-show="f.show"
              :style="'background:' + f.color"
              style="min-width:95px!important;word-wrap: break-word"
            >
              {{ parsetitulo(f.nombre) }}
            </td>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(f, ind) in estudiantes" :key="ind">
            <td>
              <v-hover v-slot="{ hover }" open-delay="100">
                <div>
                  <span> {{ f.nombre }} </span>
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out green darken-4 v-card--reveal white--text"
                      style="height: 100%; width:99%"
                    >
                      <v-icon
                        v-if="f.nombre != '--'"
                        small
                        @click="showMoreDetails(f)"
                        title="Ver detalles"
                        color="white"
                        class="mr-4"
                        >mdi-eye</v-icon
                      >
                      <v-icon
                        v-if="f.nombre != '--'"
                        small
                        @click="vermovimientos(f)"
                        title="Ver movimientos"
                        color="white"
                        class="mr-4"
                        >mdi-calendar-search</v-icon
                      >
                      <v-icon
                        v-if="iseditplan && f.nombre != '--' && hover && f.estado_ins == 1"
                        small
                        @click="editarplanpagos(f)"
                        title="Editar plan de pagos"
                        color="white"
                        class="mr-4"
                        >mdi-clipboard-edit-outline</v-icon
                      >
                      <v-icon
                        v-if="(iseditplan || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25) && f.nombre != '--' && hover"
                        small
                        @click="cambiarestadomoodle(f)"
                        title="Cambiar estado"
                        color="white"
                        class="mr-4"
                        >mdi-account-key-outline</v-icon
                      >
                    </div>
                  </v-expand-transition>
                  <v-progress-linear v-if="f.loading" indeterminate color="white"></v-progress-linear>
                </div>
              </v-hover>
            </td>

            <td
              v-for="(m, ind2) in f.montos"
              :key="ind2"
              v-show="m.show"
              class="text-right"
              :style="'background:' + m.color"
              :title="m.idconcepto + ' ' + f.nombre"
            >
              <v-menu open-on-hover top offset-y :close-on-content-click="false" :open-delay="500" tile>
                <template v-slot:activator="{ on, attrs }">
                  <span xclass="black--text" color="primary" dark v-bind="attrs" v-on="on"> {{ m.valor }} </span>
                </template>

                <div
                  v-if="f.nombre != '--'"
                  class="bg-primary pa-4"
                  style="background:#196391;min-width:800px!important"
                >
                  <h3 class="text-center white--text mt-0">{{ f.nombre }}</h3>
                  <hr class="ma-0 blue darken-2" />
                  <v-row class="mb-2">
                    <v-col class="pr-14">
                      <p class="mb-1 mt-0 text-center"><b>Retrasado:</b></p>
                      <p class="mb-1 mt-0"><b>Cuota retrasada:</b> {{ m.c.cobranza.retraso_monto }}</p>
                      <p class="mb-1 mt-0"><b>Nro cuota:</b> {{ m.c.cobranza.retraso_nro_cuota }}</p>
                      <p class="mb-1 mt-0"><b>Importe cobrado:</b> {{ m.c.cobranza.retraso_importe }}</p>
                      <p class="mb-1 mt-0"><b>Saldo por cobrar:</b> {{ m.c.cobranza.retraso_por_cobrar }}</p>
                      <p class="mb-1 mt-0"><b>Descuento:</b> {{ m.c.cobranza.retraso_descuento }}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0 text-center"><b>Vigente:</b></p>
                      <p class="mb-1 mt-0"><b>Cuota retrasada:</b> {{ m.c.cobranza.vigente_monto }}</p>
                      <p class="mb-1 mt-0"><b>Nro cuota:</b> {{ m.c.cobranza.vigente_nro_cuota }}</p>
                      <p class="mb-1 mt-0"><b>Importe cobrado:</b> {{ m.c.cobranza.vigente_importe }}</p>
                      <p class="mb-1 mt-0"><b>Saldo por cobrar:</b> {{ m.c.cobranza.vigente_por_cobrar }}</p>
                      <p class="mb-1 mt-0"><b>Descuento:</b> {{ m.c.cobranza.vigente_descuento }}</p>

                      <!-- <p class="mb-1 mt-0"><b>Nuevos por cobrar:</b> {{ m.c.vigente_descuento }}</p>
                                            <p class="mb-1 mt-0"><b>Nuevo cobrado:</b> {{ m.c.vigente_descuento }}</p>
                                            <p class="mb-1 mt-0"><b>Nuevo saldo por cobrar:</b> {{ m.c.vigente_descuento }}</p> -->
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0"><b>Importe delanto:</b> {{ m.c.cobranza.adelanto_importe }}</p>
                      <p class="mb-1 mt-0"><b>Nro cuota adelanto:</b> {{ m.c.cobranza.adelanto_nro_cuota }}</p>
                      <p class="mb-1 mt-0"><b>Concepto:</b> {{ m.c.concepto_pago }}</p>
                      <p class="mb-1 mt-0"><b>Descuento monto:</b> {{ m.c.cobranza.descuento_monto }}</p>
                      <p class="mb-1 mt-0"><b>Descuento nro cuota:</b> {{ m.c.cobranza.descuento_nro_cuota }}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0"><b>Total pagar:</b> {{ m.c.cobranza.total_pagar }}</p>
                      <p class="mb-1 mt-0"><b>Total cuotas:</b> {{ m.c.cobranza.total_cuotas }}</p>
                      <p class="mb-1 mt-0"><b>Saldo:</b> {{ m.c.saldo }}</p>
                    </v-col>
                  </v-row>
                  <hr class="ma-0 blue darken-2" />
                </div>
              </v-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="tipoasignacion && tipoasignacion.id == 2" class="table-responsive" style="height: 62vh;">
      <table
        v-if="estudiantes2.length"
        class="ctable table-hover table-condensed table-striped"
        style="min-width:100%;line-height: 1em;"
        id="midatatable"
      >
        <thead style="background:#196391;position: sticky; top: 0; z-index: 1;">
          <tr class="white--text text-center">
            <td rowspan="3" class="fixedheader" style="padding-left:12px;padding-right:12px;min-width:250px!important">
              DATOS PERSONA
            </td>
            <td v-for="(c, ind) in xconceptos" :key="ind" v-show="c.show" :style="'background:' + c.color" colspan="7">
              {{ c.concepto_pago }}
            </td>
          </tr>
          <tr class="white--text text-center" style="background:#BFAA6B;">
            <td
              v-for="(f, ind) in primerafila2"
              :key="ind"
              v-show="f.show"
              :style="'background:' + f.color"
              :colspan="f.colspan"
            >
              {{ f.nombre }}
            </td>
          </tr>
          <tr class="white--text text-center" style="background:#BFAA6B;">
            <td
              v-for="(f, ind) in segundafila2"
              :key="ind"
              v-show="f.show"
              :style="'background:' + f.color"
              style="min-width:95px!important;word-wrap: break-word"
            >
              {{ f.nombre }}
            </td>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(f, ind) in estudiantes2" :key="ind">
            <td>
              <v-icon v-if="f.nombre != '--'" small @click="showMoreDetails(f)">mdi-eye</v-icon>
              <span> {{ f.nombre }} </span>
              <v-progress-linear v-if="f.loading" indeterminate color="indigo"></v-progress-linear>
            </td>

            <td
              v-for="(m, ind2) in f.montos"
              :key="ind2"
              v-show="m.show"
              class="text-right"
              :style="'background:' + m.color"
              :title="m.idconcepto + ' ' + f.nombre"
            >
              <v-menu open-on-hover top offset-y :close-on-content-click="false" :open-delay="500" tile>
                <template v-slot:activator="{ on, attrs }">
                  <span xclass="black--text" color="primary" dark v-bind="attrs" v-on="on"> {{ m.valor }} </span>
                </template>

                <div
                  v-if="f.nombre != '--'"
                  class="bg-primary pa-4"
                  style="background:#196391;min-width:800px!important"
                >
                  <h3 class="text-center white--text mt-0">{{ f.nombre }}</h3>
                  <hr class="ma-0 blue darken-2" />
                  <v-row class="mb-2">
                    <v-col class="pr-14">
                      <p class="mb-1 mt-0 text-center"><b>Retrasado:</b></p>
                      <p class="mb-1 mt-0"><b>Cuota retrasada:</b> {{ m.c.ingresos_nuevo.retraso_monto }}</p>
                      <p class="mb-1 mt-0"><b>Nro cuota:</b> {{ m.c.ingresos_nuevo.retraso_nro_cuota }}</p>
                      <p class="mb-1 mt-0"><b>Importe cobrado:</b> {{ m.c.ingresos_nuevo.retraso_importe }}</p>
                      <p class="mb-1 mt-0"><b>Saldo por cobrar:</b> {{ m.c.ingresos_nuevo.retraso_por_cobrar }}</p>
                      <p class="mb-1 mt-0"><b>Descuento:</b> {{ m.c.ingresos_nuevo.retraso_descuento }}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0 text-center"><b>Vigente:</b></p>
                      <p class="mb-1 mt-0"><b>Cuota retrasada:</b> {{ m.c.ingresos_nuevo.vigente_monto }}</p>
                      <p class="mb-1 mt-0"><b>Nro cuota:</b> {{ m.c.ingresos_nuevo.vigente_nro_cuota }}</p>
                      <p class="mb-1 mt-0"><b>Importe cobrado:</b> {{ m.c.ingresos_nuevo.vigente_importe }}</p>
                      <p class="mb-1 mt-0"><b>Saldo por cobrar:</b> {{ m.c.ingresos_nuevo.vigente_por_cobrar }}</p>
                      <p class="mb-1 mt-0"><b>Descuento:</b> {{ m.c.ingresos_nuevo.vigente_descuento }}</p>

                      <!-- <p class="mb-1 mt-0"><b>Nuevos por cobrar:</b> {{ m.c.vigente_descuento }}</p>
                                            <p class="mb-1 mt-0"><b>Nuevo cobrado:</b> {{ m.c.vigente_descuento }}</p>
                                            <p class="mb-1 mt-0"><b>Nuevo saldo por cobrar:</b> {{ m.c.vigente_descuento }}</p> -->
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0"><b>Importe delanto:</b> {{ m.c.ingresos_nuevo.adelanto_importe }}</p>
                      <p class="mb-1 mt-0"><b>Nro cuota adelanto:</b> {{ m.c.ingresos_nuevo.adelanto_nro_cuota }}</p>
                      <p class="mb-1 mt-0"><b>Concepto:</b> {{ m.c.concepto_pago }}</p>
                      <p class="mb-1 mt-0"><b>Descuento monto:</b> {{ m.c.descuento_monto }}</p>
                      <p class="mb-1 mt-0"><b>Descuento nro cuota:</b> {{ m.c.descuento_nro_cuota }}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0"><b>Retraso descuento </b> {{ m.c.ingresos_nuevo.retraso_n_descuento }}</p>
                      <p class="mb-1 mt-0"><b>Retraso monto </b> {{ m.c.ingresos_nuevo.retraso_n_monto }}</p>
                      <p class="mb-1 mt-0"><b>Retraso importe </b> {{ m.c.ingresos_nuevo.retraso_n_importe }}</p>
                      <p class="mb-1 mt-0"><b>Retraso por cobrar </b> {{ m.c.ingresos_nuevo.retraso_n_por_cobrar }}</p>
                      <p class="mb-1 mt-0"><b>Vigente descuento </b> {{ m.c.vigente_n_descuento }}</p>
                      <p class="mb-1 mt-0"><b>Vigente monto </b> {{ m.c.vigente_n_monto }}</p>
                      <p class="mb-1 mt-0"><b>Vigente importe </b> {{ m.c.vigente_n_importe }}</p>
                      <p class="mb-1 mt-0"><b>Vigente porcobrar </b> {{ m.c.vigente_n_por_cobrar }}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0"><b>Total pagar:</b> {{ m.c.ingresos_nuevo.total_pagar }}</p>
                      <p class="mb-1 mt-0"><b>Total cuotas:</b> {{ m.c.ingresos_nuevo.total_cuotas }}</p>
                      <p class="mb-1 mt-0"><b>Saldo:</b> {{ m.c.saldo }}</p>
                    </v-col>
                  </v-row>
                  <hr class="ma-0 blue darken-2" />
                </div>
              </v-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div><plan-pagos-details ref="refPlaPagosDetail" /></div>
    <div><AMovimientos ref="refmovimientos" /></div>
    <div><AMoodleEstadoV2 ref="refmoodleestado" /></div>
  </div>
</template>

<style scoped>
  table tbody td:first-child {
    position: sticky;
    left: 0;
    background: #efefef;
    z-index: 0;
    text-align: left;
  }
  .fixedheader {
    position: sticky;
    left: 0;
    background: #196391;
    z-index: 1;
    text-align: left;
  }
  .xtable,
  tr,
  td {
    border: 1px solid #444;
  }

  /* .columna,
tbody td:nth-child(5){
    border-right: 4px solid black!important;
} */

  .xtable td:last-child {
    border: 2px solid black;
  }
  tbody tr:last-child {
    color: white !important;
  }
  tbody td:nth-child(2) {
    color: #000000;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: 1;
    position: absolute;
    width: 100%;
  }
</style>

<script>
  import xaxios from '@/xaxios';
  //import {myFunction1} from "@/components/Utils"
  import PlanPagosDetails from '@/views/Inscripcion/PlanPagosDetails';
  import AMovimientos from '@/components/AMovimientos';
  import AMoodleEstadoV2 from '@/components/AMoodleEstadoV2';
  export default {
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function(s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function(s, c) {
          return s.replace(/{(\w+)}/g, function(m, p) {
            return c[p];
          });
        },
        // END EXCEL
        colores: [
          { id: 1, c: '#7A3674' },
          { id: 2, c: '#1F6E43' },
          { id: 3, c: '#7A3674' },
          { id: 4, c: '#1F6E43' },
          { id: 5, c: '#C64832' },
        ],
        tipoasignacion: null,
        xconceptos: [],
        xconcetoschecks: [],
        estudiantes: [],
        primerafila: [{}],
        segundafila: [{}],
        estudiantes2: [],
        primerafila2: [{}],
        segundafila2: [{}],
        sumatoria: {
          retraso_importe: 0,
          vigente_importe: 0,
        },
        iseditplan: false,
        total_conceptos: [],
        total_conceptos2: [],
        plataforma: {},
        xmsg: '',
        xfiltro: '',
        idprograma: 0,
        fecha_fin: '',
        gestion: 0,
        mes: 0,
      };
    },
    watch: {
      xconcetoschecks: {
        deep: true,
        handler: function() {
          this.vshow();
        },
      },
    },
    components: { PlanPagosDetails, AMovimientos, AMoodleEstadoV2 },
    methods: {
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'REPORTE_ASIGNACION_DE_ESTUDIANTES_POR_PROGRAMA.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      findtext() {
        window.console.log('buscando...');
        if (this.xfiltro) {
          find(this.xfiltro);
          /*const vue = this;
                setTimeout(function() {
                    find(vue.xfiltro);
                    //donde esta la falla aqui
                }, 1000);*/
        }
      },
      vshow() {
        this.xconceptos.forEach((c) => {
          let ischeck = this.xconcetoschecks.find((x) => x == c.concepto_pago_id);
          if (ischeck) c.show = true;
          else c.show = false;
        });

        this.primerafila.forEach((f) => {
          let ischeck = this.xconcetoschecks.find((x) => x == f.idconcepto);
          if (ischeck) f.show = true;
          else f.show = false;
        });

        this.segundafila.forEach((f) => {
          let ischeck = this.xconcetoschecks.find((x) => x == f.idconcepto);
          if (ischeck) f.show = true;
          else f.show = false;
        });

        this.estudiantes.forEach((e) => {
          e.montos.forEach((m) => {
            let ischeck = this.xconcetoschecks.find((x) => x == m.idconcepto);
            if (ischeck) m.show = true;
            else m.show = false;
          });
        });

        this.primerafila2.forEach((f) => {
          let ischeck = this.xconcetoschecks.find((x) => x == f.idconcepto);
          if (ischeck) f.show = true;
          else f.show = false;
        });

        this.segundafila2.forEach((f) => {
          let ischeck = this.xconcetoschecks.find((x) => x == f.idconcepto);
          if (ischeck) f.show = true;
          else f.show = false;
        });

        this.estudiantes2.forEach((e) => {
          e.montos.forEach((m) => {
            let ischeck = this.xconcetoschecks.find((x) => x == m.idconcepto);
            if (ischeck) m.show = true;
            else m.show = false;
          });
        });
      },
      vermovimientos(est) {
        //window.console.log(est);
        est.nombres = est.nombre;
        let ins = {
          id: est.ins,
          estudiante: est,
        };
        this.$refs.refmovimientos.open(ins);
      },
      showMoreDetails(estud) {
        //window.console.log(estud);
        estud.loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${estud.ins}/plan-pago`;
        xaxios.get(url).then(({ data }) => {
          vue.$refs.refPlaPagosDetail.showThisView(data.data, estud.idpersona, estud.ins);
          estud.loading = false;
        });
      },
      parsetitulo(str) {
        if (!this.fecha_fin) return str;
        let date = new Date(this.fecha_fin);
        let ahora = new Date();
        ahora.setDate(1);
        ahora.setMonth(this.mes - 1);
        ahora.setFullYear(this.gestion);
        if (date.getTime() < ahora.getTime()) {
          str = str.replace('Retrasado', 'Por recuperar');
          str = str.replace('retrasada', 'por recuperar');
        }

        //window.console.log(date, ahora);
        return str;
      },
      editarplanpagos(est) {
        window.console.log(est);
        this.$router.push({
          name: 'editarplanpagos',
          params: { idprograma: est.idprograma, idpersona: est.idpersona, idinscripcion: est.ins },
        });
      },
      crearfilasycolumnas(xcon, estudiantesglobal) {
        const vue = this;
        if (estudiantesglobal == 1) {
          xcon.forEach((c, i) => {
            vue.primerafila.push({
              colspan: 1,
              nombre: 'Total ' + c.concepto_pago,
              rowspan: 2,
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });
            vue.primerafila.push({
              colspan: 4,
              nombre: 'Retrasado',
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });
            vue.primerafila.push({
              colspan: 4,
              nombre: 'Vigente',
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });
            //vue.primerafila.push({ colspan: 5, nombre: "Retrasos", color: xcon[i].color, show: false, idconcepto: c.id });
            vue.primerafila.push({
              colspan: 2,
              nombre: 'Adelantado',
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });

            //vue.segundafila.push({ nombre: "", color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila.push({ nombre: 'Cuota retrasada', color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila.push({ nombre: 'Nro cuota', color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila.push({ nombre: 'Importe cobrado', color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila.push({ nombre: 'Saldo por cobrar', color: xcon[i].color, show: false, idconcepto: c.id });

            vue.segundafila.push({ nombre: 'Cuota vigente', color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila.push({ nombre: 'Nro cuota', color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila.push({ nombre: 'Importe cobrado', color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila.push({ nombre: 'Saldo por cobrar', color: xcon[i].color, show: false, idconcepto: c.id });

            vue.segundafila.push({ nombre: 'Nro cuota', color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila.push({ nombre: 'Importe', color: xcon[i].color, show: false, idconcepto: c.id });
          });
        } else if (estudiantesglobal == 2) {
          xcon.forEach((c, i) => {
            vue.primerafila2.push({
              colspan: 7,
              nombre: 'Inscripciones',
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });

            //vue.segundafila2.push({ nombre: "", color: xcon[i].color, show: false, idconcepto: c.id });
            //vue.segundafila2.push({ nombre: "Retraso descuento", color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila2.push({
              nombre: 'Total ' + c.concepto_pago,
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });
            vue.segundafila2.push({
              nombre: 'Retraso por cobrar',
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });
            vue.segundafila2.push({ nombre: 'Retraso cobrado', color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila2.push({
              nombre: 'Retraso Saldo por cobrar',
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });

            //vue.segundafila2.push({ nombre: "", color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila2.push({
              nombre: 'Importe por cobrar',
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });
            vue.segundafila2.push({ nombre: 'Importe cobrado', color: xcon[i].color, show: false, idconcepto: c.id });
            vue.segundafila2.push({
              nombre: 'Importe Saldo por cobrar',
              color: xcon[i].color,
              show: false,
              idconcepto: c.id,
            });
          });
        }
      },
      resetasignaciones() {
        this.xconcetoschecks = [];
        this.estudiantes = [];
        this.estudiantes2 = [];
        this.xconceptos = [];
        this.primerafila = [];
        this.segundafila = [];
        this.primerafila2 = [];
        this.segundafila2 = [];
      },
      parseIns(ins) {
        var str = '';
        if (ins == 0) str = 'Pre inscrito';
        else if (ins == 1) str = 'Inscrito';
        else if (ins == 2) str = 'retirado';
        else if (ins == 3) str = 'cambiado';
        else if (ins == 4) str = 'congelado';
        else if (ins == 5) str = 'pagado';
        return str;
      },
      parseInsColor(ins) {
        if (ins == 0) return '#D1DBA4';
        else if (ins == 1) return '#ffffff';
        else if (ins == 2) return '#FFA8B1';
        else if (ins == 3) return '#FFE0A8';
        else if (ins == 4) return '#A8D3FF';
        else if (ins == 5) return '#FFA8F2';
        else return '';
      },
      stylebackground(monto, color) {
        if (monto > 0) return color;
        else return '';
      },
      setipoasignacion(tipoasignacion) {
        this.tipoasignacion = tipoasignacion;
      },
      parsecuotas(c) {
        if (!c) return '';
        let cs = c.split(',');
        let txt = '';
        cs.forEach((x) => {
          if (x) txt += x + ',';
        });
        if (txt) txt = txt.substring(0, txt.length - 1);
        return txt;
      }, 
      obtenerasignaciones(gestion, mes, programa, tipoasignacion, plataforma) {
        this.resetasignaciones();
        this.plataforma = plataforma;
        this.tipoasignacion = tipoasignacion;
        this.idprograma = programa.id;
        this.loading = true;
        this.total_conceptos = [];
        this.total_conceptos2 = [];
        this.xmsg = '';
        this.gestion = gestion;
        this.fecha_fin = programa.fecha_fin;
        this.mes = mes;
        const vue = this;
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let urlc = `${process.env.VUE_APP_API_REST}/api/pagos/conceptos/buscar`;
        let raw = JSON.stringify({ unidad_negocio_id: unidad });
        //let urla = `${process.env.VUE_APP_API_REST}/api/v1/programa/asignacion?`;
        let urla = `${process.env.VUE_APP_API_REST}/api/v1/asignacion/programa?`;
        urla += `year=${gestion}&month=${mes}&programa_id=${this.idprograma}`;
        //let urlb = `${process.env.VUE_APP_API_REST}/esam/programa/id/${idprograma}`;
        const promise1 = xaxios.post(urlc, raw);
        const promise2 = xaxios.get(urla);
        //const promise3 = axios.get(urlb);
        //window.console.log(urlb);

        Promise.all([promise1, promise2])
          .then(function(values) {
            let data1 = values[1];
            //let data2 = values[2];
            let xcon = [];
            let est = [];
            let est2 = [];
            //window.console.log('>>::', data2.data);
            if (data1.data == '') data1.data = { data: [] };

            data1.data.data.forEach((a) => {
              if (!a.conceptos) a.conceptos = [];
              if (!a.persona) {
                /* window.console.log('==========================');
                window.console.log(JSON.stringify(a, null, 4));
                window.console.log('=========================='); */
                a.persona = {};
              }
              let xper = {
                idpersona: a.persona.id,
                nombre: a.persona.primer_apellido + ' ' + a.persona.segundo_apellido + ' ' + a.persona.nombres,
                ins: a.inscripcion_id,
                loading: false,
                montos: [],
                estado_ins: a.estado_ins,
                idprograma: vue.idprograma,
              };
              let xper2 = {
                idpersona: a.persona.id,
                nombre: a.persona.primer_apellido + ' ' + a.persona.segundo_apellido + ' ' + a.persona.nombres,
                ins: a.inscripcion_id,
                loading: false,
                montos: [],
                estado_ins: a.estado_ins,
                idprograma: vue.idprograma,
              };
              a.conceptos.forEach((c) => {
                let exis = xcon.find((xc) => xc.concepto_pago_id == c.concepto_pago_id);
                let concepto = window.Object.assign({}, c);
                let color = vue.colores.find((col) => col.id == concepto.concepto_pago_id);
                if (!color) color = vue.colores[0];
                concepto.color = color.c;
                concepto.show = false;
                concepto.id = c.concepto_pago_id;
                if (!exis && c.concepto_pago_id > 0) {
                  // hay un concepto vacio que tiene id 0, lo controlo aqui nomas
                  xcon.push(concepto);
                }

                xper.montos.push({
                  valor: vue.parsecomas(c.cobranza.total_pagar) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: '',
                }); //cuota retrasada
                xper.montos.push({
                  valor: vue.parsecomas(c.cobranza.retraso_monto) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: '',
                }); //cuota retrasada
                xper.montos.push({
                  valor: vue.parsecuotas(c.cobranza.retraso_nro_cuota),
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: '',
                }); //nro cuota
                xper.montos.push({
                  valor: vue.parsecomas(c.cobranza.retraso_importe) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: '',
                }); //importe
                xper.montos.push({
                  valor: vue.parsecomas(c.cobranza.retraso_por_cobrar) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: vue.stylebackground(c.retraso_por_cobrar, '#D86060'),
                }); //saldo por cobrar

                xper.montos.push({
                  valor: vue.parsecomas(c.cobranza.vigente_monto) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //cuota vigente
                xper.montos.push({
                  valor: vue.parsecuotas(c.cobranza.vigente_nro_cuota),
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //nro cuota
                xper.montos.push({
                  valor: vue.parsecomas(c.cobranza.vigente_importe) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //importe
                xper.montos.push({
                  valor: vue.parsecomas(c.cobranza.vigente_por_cobrar) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: vue.stylebackground(c.vigente_por_cobrar, '#D8D260'),
                }); //saldo por cobrar

                //xper2.montos.push({ valor: "", show: false, c: concepto, idconcepto: c.concepto_pago_id, color: concepto.color + "11" }); //nuevos
                //xper2.montos.push({ valor: vue.parsecomas(c.retraso_n_descuento) + " Bs.", show: false, c: concepto, idconcepto: c.concepto_pago_id, color: concepto.color + "11" }); //nuevos
                xper2.montos.push({
                  valor: vue.parsecomas(c.ingresos_nuevo.total_pagar) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //nuevos
                xper2.montos.push({
                  valor: vue.parsecomas(c.ingresos_nuevo.retraso_monto) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //nuevos
                xper2.montos.push({
                  valor: vue.parsecomas(c.ingresos_nuevo.retraso_importe) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //nuevos
                xper2.montos.push({
                  valor: vue.parsecomas(c.ingresos_nuevo.retraso_por_cobrar) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //nuevos

                //xper2.montos.push({ valor: "", show: false, c: concepto, idconcepto: c.concepto_pago_id, color: concepto.color + "11" }); //nuevos
                xper2.montos.push({
                  valor: vue.parsecomas(c.ingresos_nuevo.vigente_monto) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //nuevos
                xper2.montos.push({
                  valor: vue.parsecomas(c.ingresos_nuevo.vigente_importe) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //nuevos
                xper2.montos.push({
                  valor: vue.parsecomas(c.ingresos_nuevo.vigente_por_cobrar) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: concepto.color + '11',
                }); //nuevos

                xper.montos.push({
                  valor: vue.parsecuotas(c.cobranza.adelanto_nro_cuota),
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: '',
                }); //nro cuota
                xper.montos.push({
                  valor: vue.parsecomas(c.cobranza.adelanto_importe) + ' Bs.',
                  show: false,
                  c: concepto,
                  idconcepto: c.concepto_pago_id,
                  color: '',
                }); //importe

                let existe = vue.total_conceptos.find((tc) => tc.idconcepto == c.concepto_pago_id);
                let existe2 = vue.total_conceptos2.find((tc) => tc.idconcepto == c.concepto_pago_id);
                //window.console.log("EXISTE>> ", c.concepto_pago_id, existe);
                if (existe) {
                  existe.totales.total_pagar += c.cobranza.total_pagar;
                  existe.totales.retraso_monto += c.cobranza.retraso_monto;
                  existe.totales.retraso_importe += c.cobranza.retraso_importe;
                  existe.totales.retraso_por_cobrar += c.cobranza.retraso_por_cobrar;
                  existe.totales.vigente_monto += c.cobranza.vigente_monto;
                  existe.totales.vigente_importe += c.cobranza.vigente_importe;
                  existe.totales.vigente_por_cobrar += c.cobranza.vigente_por_cobrar;
                  existe.totales.adelanto_importe += c.cobranza.adelanto_importe;
                } else {
                  let totales = {};
                  totales.total_pagar = c.cobranza.total_pagar;
                  totales.retraso_monto = c.cobranza.retraso_monto;
                  totales.retraso_importe = c.cobranza.retraso_importe;
                  totales.retraso_por_cobrar = c.cobranza.retraso_por_cobrar;
                  totales.vigente_monto = c.cobranza.vigente_monto;
                  totales.vigente_importe = c.cobranza.vigente_importe;
                  totales.vigente_por_cobrar = c.cobranza.vigente_por_cobrar;
                  totales.adelanto_importe = c.cobranza.adelanto_importe;
                  totales.idconcepto = c.concepto_pago_id;
                  totales.show = false;
                  totales.c = concepto;
                  vue.total_conceptos.push({ idconcepto: c.concepto_pago_id, totales: totales });
                }

                if (existe2) {
                  existe2.totales.total_pagar += c.ingresos_nuevo.total_pagar;
                  existe2.totales.retraso_n_monto += c.ingresos_nuevo.retraso_monto;
                  existe2.totales.retraso_n_importe += c.ingresos_nuevo.retraso_importe;
                  existe2.totales.retraso_n_por_cobrar += c.ingresos_nuevo.retraso_por_cobrar;
                  existe2.totales.vigente_n_monto += c.ingresos_nuevo.vigente_monto;
                  existe2.totales.vigente_n_importe += c.ingresos_nuevo.vigente_importe;
                  existe2.totales.vigente_n_por_cobrar += c.ingresos_nuevo.vigente_por_cobrar;
                } else {
                  let totales2 = {};
                  totales2.idconcepto = c.concepto_pago_id;
                  totales2.total_pagar = c.ingresos_nuevo.total_pagar;
                  totales2.retraso_n_monto = c.ingresos_nuevo.retraso_monto;
                  totales2.retraso_n_importe = c.ingresos_nuevo.retraso_importe;
                  totales2.retraso_n_por_cobrar = c.ingresos_nuevo.retraso_por_cobrar;
                  totales2.vigente_n_monto = c.ingresos_nuevo.vigente_monto;
                  totales2.vigente_n_importe = c.ingresos_nuevo.vigente_importe;
                  totales2.vigente_n_por_cobrar = c.ingresos_nuevo.vigente_por_cobrar;
                  totales2.show = false;
                  totales2.c = concepto;
                  vue.total_conceptos2.push({ idconcepto: c.concepto_pago_id, totales: totales2 });
                }
              });
              est.push(xper);
              est2.push(xper2);
            });
            vue.sortbyconceptos(xcon, est, 1);
            vue.sortbyconceptos(xcon, est2, 2);

            window.console.log('TOTALES', vue.total_conceptos);
            window.console.log('TOTALES2', vue.total_conceptos2);
            //NOTA: nombre : --, esos dos guiones los uso para ocultar el menu flotante y el ojito de plan de pagos en la table
            let xper = { nombre: '--', ins: -1, loading: false, montos: [] };
            let xper2 = { nombre: '--', ins: -1, loading: false, montos: [] };
            vue.total_conceptos.forEach((c) => {
              xper.montos.push({
                valor: vue.parsecomas(c.totales.total_pagar) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //cuota retrasada
              xper.montos.push({
                valor: vue.parsecomas(c.totales.retraso_monto) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //cuota retrasada
              xper.montos.push({
                valor: c.totales.retraso_nro_cuota,
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nro cuota
              xper.montos.push({
                valor: vue.parsecomas(c.totales.retraso_importe) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //importe
              xper.montos.push({
                valor: vue.parsecomas(c.totales.retraso_por_cobrar) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //saldo por cobrar

              xper.montos.push({
                valor: vue.parsecomas(c.totales.vigente_monto) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //cuota vigente
              xper.montos.push({
                valor: c.totales.vigente_nro_cuota,
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nro cuota
              xper.montos.push({
                valor: vue.parsecomas(c.totales.vigente_importe) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //importe
              xper.montos.push({
                valor: vue.parsecomas(c.totales.vigente_por_cobrar) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //saldo por cobrar

              xper.montos.push({
                valor: c.totales.adelanto_nro_cuota,
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nro cuota
              xper.montos.push({
                valor: vue.parsecomas(c.totales.adelanto_importe) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //importe
            });
            vue.total_conceptos2.forEach((c) => {
              //xper2.montos.push({ valor: vue.parsecomas(c.totales.retraso_n_descuento) + " Bs.", show: false, c: {}, idconcepto: c.totales.idconcepto, color: "#1F6E43" }); //nuevos
              xper2.montos.push({
                valor: vue.parsecomas(c.totales.total_pagar) + ' Bs..',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nuevos
              xper2.montos.push({
                valor: vue.parsecomas(c.totales.retraso_n_monto) + ' Bs..',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nuevos
              xper2.montos.push({
                valor: vue.parsecomas(c.totales.retraso_n_importe) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nuevos
              xper2.montos.push({
                valor: vue.parsecomas(c.totales.retraso_n_por_cobrar) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nuevos
              //xper2.montos.push({ valor: "", show: false, c: {}, idconcepto: c.totales.idconcepto, color: "#1F6E43" }); //nuevos vacios
              xper2.montos.push({
                valor: vue.parsecomas(c.totales.vigente_n_monto) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nuevos
              xper2.montos.push({
                valor: vue.parsecomas(c.totales.vigente_n_importe) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nuevos
              xper2.montos.push({
                valor: vue.parsecomas(c.totales.vigente_n_por_cobrar) + ' Bs.',
                show: false,
                c: {},
                idconcepto: c.totales.idconcepto,
                color: '#1F6E43',
              }); //nuevos
            });
            est.push(xper);
            est2.push(xper2);

            vue.loading = false;
            if (vue.xconceptos.length == 0) {
              vue.xmsg = 'No se han encontrado conceptos en este programa.';
            }
            vue.$emit('dataloaded');
          })
          .catch((e) => {
            window.console.error(e);
            vue.loading = false;
            if (e.response.status == 403) {
              vue.xmsg = 'Vuelva a acceder al sistema, su session ha caducado.';
            } else if (e.response.status == 500) {
              vue.xmsg =
                '(500) Actualmente estamos teniendo inconvientes al obtener los datos, lamentamos las molestias causadas :)';
            }
            vue.$emit('dataloaded');
          });
      },

      sortbyconceptos(xcon, est, estudiantesglobal) {
        xcon.sort((a, b) => {
          if (a.concepto_pago_id < b.concepto_pago_id) return -1;
          else if (a.concepto_pago_id > b.concepto_pago_id) return 1;
          else return 0;
        });
        if (estudiantesglobal == 1) {
          this.total_conceptos.sort((a, b) => {
            // fix, columnas totales
            if (a.idconcepto < b.idconcepto) return -1;
            else if (a.idconcepto > b.idconcepto) return 1;
            else return 0;
          });
        }
        if (estudiantesglobal == 2) {
          this.total_conceptos2.sort((a, b) => {
            // fix, columnas totales
            if (a.idconcepto < b.idconcepto) return -1;
            else if (a.idconcepto > b.idconcepto) return 1;
            else return 0;
          });
        }
        est.sort((a, b) => {
          return b.estado_ins - a.estado_ins || a.nombre.localeCompare(b.nombre);
        });
        this.llenarconceptosfaltes(xcon, est, estudiantesglobal);
        est.forEach((e) => {
          e.montos.sort((a, b) => {
            if (a.idconcepto < b.idconcepto) return -1;
            else if (a.idconcepto > b.idconcepto) return 1;
            else return 0;
          });
        });

        if (estudiantesglobal == 1) this.crearfilasycolumnas(xcon, estudiantesglobal);
        else if (estudiantesglobal == 2) this.crearfilasycolumnas(xcon, estudiantesglobal);
        this.xconceptos = xcon;
        //this.estudiantes = est;
        if (estudiantesglobal == 1) this.estudiantes = est;
        else if (estudiantesglobal == 2) this.estudiantes2 = est;
      },
      llenarconceptosfaltes(xcon, est, estudiantesglobal) {
        xcon.forEach((c) => {
          est.forEach((e) => {
            let con = e.montos.find((m) => m.idconcepto == c.concepto_pago_id);
            if (!con) this.llenarconceptovacio(e, c, estudiantesglobal);
          });
        });
      },
      parsecomas(str) {
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      llenarconceptovacio(estudent, xconc, estudiantesglobal) {
        //window.console.log(estudent.nombre, xconc);
        let color = this.parseInsColor(estudent.estado_ins);
        let estado = this.parseIns(estudent.estado_ins);
        let conceptotxt = '';
        if (estudent.estado_ins == 1) {
          estado = '-';
          //conceptotxt = 'Sin '+xconc.concepto_pago;
        }
        if (estudiantesglobal == 1) {
          estudent.montos.push({
            valor: estado,
            show: false,
            c: xconc,
            idconcepto: xconc.concepto_pago_id,
            color: color,
          }); //cuota retrasada
          estudent.montos.push({
            valor: conceptotxt,
            show: false,
            c: xconc,
            idconcepto: xconc.concepto_pago_id,
            color: color,
          }); //cuota retrasada
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); //nro cuota
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); //importe
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); //saldo por cobrar

          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); //cuota vigente
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); //nro cuota
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); //importe
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); //saldo por cobrar

          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); //nro cuota
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); //importe
        } else if (estudiantesglobal == 2) {
          //estudent.montos.push({ valor: "", show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: xconc.color + "11" }); // retraso vacio
          //estudent.montos.push({ valor: "", show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: xconc.color + "11" }); // retraso
          estudent.montos.push({
            valor: estado,
            show: false,
            c: xconc,
            idconcepto: xconc.concepto_pago_id,
            color: color,
          }); // retraso
          estudent.montos.push({
            valor: '',
            show: false,
            c: xconc,
            idconcepto: xconc.concepto_pago_id,
            color: color,
          }); // retraso
          estudent.montos.push({
            valor: conceptotxt,
            show: false,
            c: xconc,
            idconcepto: xconc.concepto_pago_id,
            color: color,
          }); // retraso
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); // retraso

          //estudent.montos.push({ valor: "", show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); // nuevos vacio
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); // nuevos
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); // nuevos
          estudent.montos.push({ valor: '', show: false, c: xconc, idconcepto: xconc.concepto_pago_id, color: color }); // nuevos
        }
      },
      cambiarestadomoodle(est) {
        //window.console.log(JSON.stringify(est, null, 4));
        this.$refs.refmoodleestado.openmodal(this.idprograma, est.idpersona, est.ins, this.plataforma);
      },
    },
    mounted() {
      //this.crearfilasycolumnas();
      this.iseditplan =
        this.$store.state.CARGO.id == 19 || this.$store.state.CARGO.id == 14 || this.$store.state.CARGO.id == 1;
    },
  };
</script>
